import { render, staticRenderFns } from "./ArchivedWorkScheduleDetails.vue?vue&type=template&id=c8326888&scoped=true"
import script from "./ArchivedWorkScheduleDetails.vue?vue&type=script&lang=js"
export * from "./ArchivedWorkScheduleDetails.vue?vue&type=script&lang=js"
import style0 from "./ArchivedWorkScheduleDetails.vue?vue&type=style&index=0&id=c8326888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8326888",
  null
  
)

export default component.exports